import { Component, Input, OnInit } from '@angular/core';

import { StateService } from '@uirouter/angular';
import { AdminService } from '../../../../services/core.admin.service';

import * as _ from 'lodash-es';
@Component({
    selector: 'site-admin-homepage-header',
    template: require('./site.admin.homepage.header.component.html')
})
export class SiteAdminHomepageHeaderComponent implements OnInit {

    @Input() setting: any = null;

    private onOff = { 'Standard': 'N', 'Custom': 'Y' };

    constructor(
        public stateService: StateService,
        private adminService: AdminService,
    ) { }
    
    ngOnInit() {
    };

    homepageSettingCallback(optionValue) {
        if (!_.isEmpty(optionValue)) {
            const params = {
                settingName: 'useCustomSiteSplash', 
                section: 'admin', 
                refId: 0, 
                settingValue: optionValue
            };
            this.adminService.postConfig(params)
            .then(() =>  {
                this.setting.useCustomSiteSplash = optionValue;
                this.stateService.reload();
            }, (response) => { console.log(response); });
        }
    };

    isCustomSiteSplashEnabled(): boolean {
        const value = _.get(this.setting, 'useCustomSiteSplash', 'N');
        return value === 'Y'
            || value === 'y'
            || value === true
            || value === 'true'
            || value === 1
            || value === '1';
    }
};